<template>

    <div class="docs_error">
        <p>Не удалось ничего найти!</p>
    </div>
    
</template>

<script>
export default {
    name: 'Error'
}
</script>

<style lang="sass">
.docs_error
    width: 70%
    p
        padding: 15px 10px
        background-color: #c92525
        font-size: 14px
        color: #fff
</style>